<div class="controls-container">
    <div class="controls-header">Bar</div>
    <div class="controls-padding"></div>
    <pm-bar [Name]="Bar.Name" [Items]="Bar.Items">
        <div class="pm-bar-button-drop-down">
            <pm-context-menu-item>Item 2</pm-context-menu-item>
            <pm-context-menu-item>Item 4</pm-context-menu-item>
        </div>
        <div class="pm-bar-buttons-left">
            <pm-button class="toolbar-button-container" ButtonClass="button-toolbar">
                <pm-icon-shield IconSize="1" IconClass="icon-blue"></pm-icon-shield>
            </pm-button>
        </div>
        <div class="pm-bar-buttons-right">
            <pm-button class="toolbar-button-container" ButtonClass="button-toolbar">
                <pm-icon-star IconSize="1" IconClass="icon-yellow"></pm-icon-star>
            </pm-button>
        </div>        
    </pm-bar>

    <div class="controls-padding"></div>
    
    <!-- <pm-properties [Item]="BarControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/bar/bar.html